var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstadiaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,22c2.2,0,4.1-0.8,5.6-2.4S32,16.2,32,14V8H16v6c0,2.2,0.8,4.1,2.4,5.6S21.8,22,24,22z M8,44v-4h4v-6 c0-2,0.5-3.9,1.4-5.7s2.3-3.2,4-4.3c-1.7-1.1-3-2.5-4-4.3S12,16,12,14V8H8V4h32v4h-4v6c0,2-0.5,3.9-1.4,5.7s-2.3,3.2-4,4.3 c1.7,1.1,3,2.5,4,4.3S36,32,36,34v6h4v4H8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstadiaIcon);
export default __webpack_public_path__ + "static/media/EstadiaIcon.2149163ed2e523b3512a98a36c9dcbad.svg";
export { ForwardRef as ReactComponent };